import ApiService from './ApiService';

class SecurityService {
  async getSecurities() {
    try {
      const response = await ApiService.call('/secured/get_security_list', 'GET');
      let data = response;

      return {
        securityDataList: data.securityDataList,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
}
export default new SecurityService();
